import React, {Fragment} from "react";
import PropTypes from "prop-types";
import withLayout from "../../../components/desktop/layout/component";
import withReducer from "../../../components/shared/with-reducer";
import ErrorHandler from "../../../components/shared/with-error-handler";
import SchemaHome from "../../../components/shared/schema-homepage";
import injectableReducers from "./injectable";
import MetaTags from "../../../components/shared/meta-tags";
import SellUsedLuxuryCars from "../../../components/desktop/sell-used-luxury-car";

const SellUsedLuxuryCarsContainer = ({ match }) => {
    return (
        <Fragment>
            <ErrorHandler>
                <MetaTags match={match} isIndexEnabled={true} />
            </ErrorHandler>
            <ErrorHandler>
                <SellUsedLuxuryCars />
            </ErrorHandler>
            <ErrorHandler>
                <SchemaHome />
            </ErrorHandler>
        </Fragment>
    );
};

SellUsedLuxuryCarsContainer.propTypes = {
    match: PropTypes.object.isRequired
};

export default withReducer(injectableReducers)(() => ({}), dispatch => ({ dispatch }))(
    withLayout(
        SellUsedLuxuryCarsContainer,
        true,
        true,
        true,
        true,
        {
            headerProps: {
                eliteCarHeader: true
            },
            footerProps: {
                gradientColor: "#000000",
                eliteCarFooter: true
            }
        }
    )
);
